import React from 'react';

import LocaleContextProvider from './components/context/LocaleContext';
import LocalizedStringsContextProvider from './components/context/LocalizedStringsContext';

import Routes from './components/routes';
import SessionTimeout from './components/design/session-timeout';

const App = () => {
  return (
    <LocaleContextProvider>
      <LocalizedStringsContextProvider>
        <SessionTimeout>
          <Routes />
        </SessionTimeout>
      </LocalizedStringsContextProvider>
    </LocaleContextProvider>
  );
};

export default App;
